import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoginForm from './components/LoginForm';

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/vacancy', { replace: true });
  }, [user, navigate]);

  const handleLogin = async (loginVal: string, password: string) => {
    const ok = await login(loginVal, password);
    if (ok) navigate('/vacancy', { replace: true });
    return ok;
  };

  return (
    <div className="min-h-screen flex bg-background-50 p-2 md:p-3 gap-3">
      {/* Left branding panel */}
      <div className="hidden lg:flex lg:w-[45%] relative flex-col items-center justify-center overflow-hidden rounded-[2.5rem] cosmos-hero isolate">
        <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
          <div className="cosmos-glow-blue animate-aurora absolute -left-[15%] top-[8%] h-[30rem] w-[30rem] opacity-70 blur-3xl" />
          <div className="cosmos-glow-pink animate-float-slower absolute -right-[12%] bottom-[-8%] h-[26rem] w-[26rem] opacity-45 blur-3xl" />
          <div className="grain absolute inset-0 opacity-[0.12]" />
        </div>

        <div className="relative z-10 flex flex-col items-center text-center px-12">
          <div className="mb-10">
            <div className="w-24 h-24 rounded-3xl flex items-center justify-center border border-white/15 bg-white/[0.06] backdrop-blur-md">
              <i className="ri-shield-user-line text-5xl text-white" />
            </div>
          </div>
          <h2 className="display text-4xl text-white mb-4">
            Корпоративный портал
          </h2>
          <p className="text-white/50 text-sm tracking-wide mb-6">для сотрудников</p>
          <p className="text-white/70 text-base leading-relaxed max-w-xs">
            Единое пространство для управления вашим рабочим процессом,
            расписанием и выплатами
          </p>

          <div className="mt-14 grid grid-cols-3 gap-6 w-full">
            {[
              { icon: 'ri-calendar-check-line', label: 'Расписание' },
              { icon: 'ri-wallet-3-line', label: 'Выплаты' },
              { icon: 'ri-folder-line', label: 'Проекты' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/10 border border-white/15">
                  <i className={`${item.icon} text-white text-xl`} />
                </div>
                <span className="text-xs text-white/60">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-6 text-xs text-white/35 z-10">
          v1.0.0 &nbsp;·&nbsp; 2026
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 lg:px-16">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-background-100 border border-background-200">
            <i className="ri-shield-user-line text-2xl text-foreground-900" />
          </div>
        </div>

        <div className="w-full max-w-sm">
          <div className="mb-8">
            <h1 className="display-tight text-3xl text-foreground-900 mb-2">Добро пожаловать</h1>
            <p className="text-foreground-500 text-sm">Введите данные для входа в систему</p>
          </div>

          <LoginForm onLogin={handleLogin} />
        </div>

        <p className="mt-12 text-xs text-foreground-400 text-center">
          Нет аккаунта? Обратитесь к вашему HR-менеджеру.
        </p>
      </div>
    </div>
  );
}
